/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react'
import {KTIcon} from '../../../helpers'
import { Link } from 'react-router-dom'
import { OverlayTrigger,Popover } from 'react-bootstrap'
type Props = {
  className: string
}

const popoverContent = (
  <Popover id="popover-basic" style={{ color: 'white', border: '2px solid #00BCD1' }}>
    <Popover.Header as="h3" >Change Request</Popover.Header>
    <Popover.Body>
    Open a change request for modifications, updates, or alterations to your CTX.
    </Popover.Body>
  </Popover>
);
const incident = (
  <Popover id="popover-basic" style={{ color: 'white', border: '2px solid #FF4089' }}>
    <Popover.Header as="h3" >Incident Report</Popover.Header>
    <Popover.Body>
    Open an incident report when an unexpected event is present within your CTX that causes or may cause downtime on customer's network.
    </Popover.Body>
  </Popover>
);
const feature = (
  <Popover id="popover-basic" style={{ color: 'white', border: '2px solid #223357' }}>
    <Popover.Header as="h3" >Feature Request</Popover.Header>
    <Popover.Body>
    Open Feature request as formal request suggesting the addition of a new capability or improvement to CTX dashboard, Hub or Reflector.    </Popover.Body>
  </Popover>
);

const Help = (
  <Popover id="popover-basic" style={{ color: 'white', border: '2px solid #223357' }}>
    <Popover.Header as="h3" >Help Request</Popover.Header>
    <Popover.Body>
    Ask for assistance, guidance, or support for CTX that doesn’t represent any issue on the operation of the network.</Popover.Body>
  </Popover>
);

const ListsWidget6: React.FC<Props> = ({className}) => {
  return (
    <div className='card card-xl-stretch mb-5 mb-xl-8 text-marino f-bold'>
    

      {/* end::Header */}
      {/* begin::Body */}
      <div className='card-body pt-0'>
        {/* begin::Item */}
       
        <div className='d-flex align-items-center  bg-light-azul rounded p-5 mb-7'>
          {/* begin::Icon */}
          <span className=' text-azul me-5'>
            <KTIcon iconName='bi bi-exclamation-diamond' className='text-azul fs-1 me-5' />
          </span>
          {/* end::Icon */}
          {/* begin::Title */}
         
          <div className='flex-grow-1 me-2'>
          
            <Link to='/changerequest' className='fw-bold text-azul text-hover-primary fs-6'>
              Change Request  
              <OverlayTrigger
              trigger={['hover', 'focus']}
              placement="right"
              overlay={popoverContent}
            >
              <i style={{color:'#00BCD1'}}
                className='fas fa-exclamation-circle ms-2 fs-7'
                title=''>                  
              </i>
              </OverlayTrigger>

            </Link>

            <span className='text-muted fw-semibold d-block'></span>
          </div>

          {/* end::Title */}
          {/* begin::Lable */}
          {/* end::Lable */}
        </div>
        {/* end::Item */}


        {/* begin::Item */}
        <div className='d-flex align-items-center bg-light-pink  rounded p-5 mb-7'>
          {/* begin::Icon */}
          <span className=' text-pink me-5'>
            <KTIcon iconName='bi bi-headset' className='text-pink  fs-1 me-5' />
          </span>
          {/* end::Icon */}
          {/* begin::Title */}
          <div className='flex-grow-1 me-2'>
            <Link to='/problemreport' className='fw-bold text-pink text-hover-primary fs-6'>
            Incident Report
            <OverlayTrigger
              trigger={['hover', 'focus']}
              placement="right"
              overlay={incident}
            >
              <i 
                className='fas fa-exclamation-circle ms-2 fs-7'
                title=''>                  
              </i>
              </OverlayTrigger>
            </Link>
            <span className='text-muted fw-semibold d-block'></span>
          </div>
          {/* end::Title */}
        </div>
        {/* end::Item */}
        {/* begin::Item */}
        <div className='d-flex align-items-center bg-light-marino rounded p-5 mb-7'>
          {/* begin::Icon */}
          <span className=' text-cian me-5'>
            <KTIcon iconName='bi bi-lightbulb' className='text-marino fs-1 me-5' />
          </span>
          {/* end::Icon */}
          {/* begin::Title */}
          <div className='flex-grow-1 me-2'>
            <Link to='/featurerequest' className='fw-bold text-marino text-hover-primary fs-6'>
               Feature Request
               <OverlayTrigger
                  trigger={['hover', 'focus']}
                  placement="right"
                  overlay={feature}
                >
                  <i style={{color:'#223357'}}
                    className='fas fa-exclamation-circle ms-2 fs-7'
                    title=''>                  
                  </i>
                </OverlayTrigger>
            </Link>
            <span className='text-muted fw-semibold d-block'></span>
          </div>
          {/* end::Title */}
        </div>

       <div className='d-flex align-items-center bg-light-warning rounded p-5 mb-7'>
          <span className=' text-cian me-5'>
            <KTIcon iconName='bi bi-question-circle' className='text-warning fs-1 me-5' />
          </span>
          <div className='flex-grow-1 me-2'>
            <Link to='/helprequest' className='fw-bold text-warning text-hover-primary fs-6'>
               Help Request
               <OverlayTrigger
                  trigger={['hover', 'focus']}
                  placement="right"
                  overlay={Help}
                >
                  <i style={{color:'#ffc700'}}
                    className='fas fa-exclamation-circle ms-2 fs-7'
                    title=''>                  
                  </i>
                </OverlayTrigger>
            </Link>
            <span className='text-muted fw-semibold d-block'></span>
          </div>
        </div>
        {/* end::Item */}

      </div>
      {/* end::Body */}
    </div>
  )
}

export {ListsWidget6}
